import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  BeverageType,
  BeverageTypeValues,
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesCateringBeverage,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionCateringBeverageDto } from './dto.type';

export class QuestionCateringBeverageMapper {
  static dtoToEntity(
    dto: QuestionCateringBeverageDto,
  ): ImpactCo2Answer<ValuesCateringBeverage> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'CATERING_BEVERAGE',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        beverageType: validateValueInType<BeverageType>(
          dto.beverageType,
          BeverageTypeValues,
        ),
        beverageCount: dto.beverageCount,
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesCateringBeverage>,
    projectId: number,
  ): Omit<
    QuestionCateringBeverageDto,
    'id' | 'userId' | 'score' | 'isExternal'
  > {
    return {
      projectId: projectId,
      sector: answer.sector,
      beverageType: answer.values.beverageType,
      beverageCount: answer.values.beverageCount,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
